import { render } from "./OurBids.vue?vue&type=template&id=71bc5c3d"
import script from "./OurBids.vue?vue&type=script&lang=js"
export * from "./OurBids.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__